import { get } from "lodash"
import { numberFormatter } from "helpers/formatters/numbers"
import { makeContributorsGroupDropdownSelector } from "helpers/contributors"

const columns = {
  group: [{
    id: "name",
    label: "",
    align: "left",
    getter: get,
  }, {
    id: "totalPercentEquity",
    label: "% GMV",
    getter: get,
    formatter: (number) => numberFormatter(number * 100),
  }],
  details: [],
}

export const getGroupsDropdownColumns = makeContributorsGroupDropdownSelector(columns)
